import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonModal, IonTitle, IonToolbar } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface HoleListSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  totalHoles: number;
  activeHole: number;
  onSelectHole: (hole: number) => void;
  holeData: any[];
  parentElement: HTMLElement;
}

const HoleListSelector: React.FC<HoleListSelectorProps> = ({
  isOpen,
  onClose,
  totalHoles,
  activeHole,
  onSelectHole,
  holeData,
  parentElement
}) => {
  const { t } = useTranslation();

  // Generate an array of hole numbers
  const holes = Array.from({ length: totalHoles }, (_, i) => i + 1);
  const [presentingElement, setPresentingElement] = useState<HTMLElement | null>(parentElement);
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} className="hole-list-modal" presentingElement={presentingElement!}>
      <IonHeader className="ion-no-border">
        <IonToolbar color="dark">
          <IonTitle>{t('holes')}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>
              <IonIcon icon={closeOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent color="dark" className="ion-padding">
        <div className="grid grid-cols-3 gap-3">
          {holes.map((hole) => (
            <button
              key={hole}
              onClick={() => {
                onSelectHole(hole);
                onClose();
              }}
              className={`p-3 rounded-xl border flex flex-col items-center justify-center ${activeHole === hole
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-card border-input border-solid'
                }`}
            >
              <div className="flex items-center justify-center mb-1">
                <span className="text-xl font-bold">{String(hole).padStart(2, '0')}</span>
              </div>
              <div className="flex text-xs gap-1">
                {[...Array(holeData[hole - 1]?.par || 0)].map((_, index) => (
                  <span className="size-1 rounded-full bg-foreground" key={index}></span>
                ))}
              </div>
            </button>
          ))}
        </div>
      </IonContent>
    </IonModal>
  );
};

export default HoleListSelector;
